import { render, staticRenderFns } from "./ManageProcedures.vue?vue&type=template&id=5b7eeb1a&"
import script from "./ManageProcedures.vue?vue&type=script&lang=js&"
export * from "./ManageProcedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports